import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-text-outer"
};
const _hoisted_3 = {
  class: "footer-text1 footer-text-col"
};
const _hoisted_4 = {
  class: "footer-text2 footer-text-col"
};
const _hoisted_5 = {
  class: "footer-text3 footer-text-col"
};
const _hoisted_6 = {
  class: "footer-text4 footer-text-col"
};
import { useRouter } from "vue-router";
export default {
  __name: 'common_foot',
  setup(__props) {
    // 引入 router，构造 to 函数
    const router = useRouter();
    const to = url => {
      router.push(url);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "footer_underline"
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "footer-text1-t1 footer-text foot-title",
        onClick: _cache[0] || (_cache[0] = $event => to('/about/index'))
      }, " About Us "), _createElementVNode("div", {
        class: "footer-text1-t2 footer-text",
        onClick: _cache[1] || (_cache[1] = $event => to('/about/our_story'))
      }, " Our Story "), _createElementVNode("div", {
        class: "footer-text1-t3 footer-text",
        onClick: _cache[2] || (_cache[2] = $event => to('/about/our_credo'))
      }, " Our Credo "), _createElementVNode("div", {
        class: "footer-text1-t4 footer-text",
        onClick: _cache[3] || (_cache[3] = $event => to('/about/our_mission'))
      }, " Our Mission "), _createElementVNode("div", {
        class: "footer-text1-t5 footer-text",
        onClick: _cache[4] || (_cache[4] = $event => to('/about/our_values'))
      }, " Our Values "), _createElementVNode("div", {
        class: "footer-text1-t6 footer-text",
        onClick: _cache[5] || (_cache[5] = $event => to('/about/our_creations'))
      }, _cache[18] || (_cache[18] = [_createTextVNode(" Our Innovation & "), _createElementVNode("br", null, null, -1), _createTextVNode(" Creativity Center ")]))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "footer-text2-t1 footer-text foot-title",
        onClick: _cache[6] || (_cache[6] = $event => to('/global/index'))
      }, " Global Sourcing "), _createElementVNode("div", {
        class: "footer-text2-t2 footer-text",
        onClick: _cache[7] || (_cache[7] = $event => to('/global/saffron'))
      }, " Saffron "), _createElementVNode("div", {
        class: "footer-text2-t3 footer-text",
        onClick: _cache[8] || (_cache[8] = $event => to('/global/fig'))
      }, " Figs "), _createElementVNode("div", {
        class: "footer-text2-t4 footer-text",
        onClick: _cache[9] || (_cache[9] = $event => to('/global/pistachio'))
      }, " Pistachios "), _createElementVNode("div", {
        class: "footer-text2-t5 footer-text",
        onClick: _cache[10] || (_cache[10] = $event => to('/global/order'))
      }, " Inquiry ")]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "footer-text3-t1 footer-text foot-title",
        onClick: _cache[11] || (_cache[11] = $event => to('/career/index'))
      }, " Career "), _createElementVNode("div", {
        class: "footer-text3-t2 footer-text",
        onClick: _cache[12] || (_cache[12] = $event => to('/career/what_we_do'))
      }, " What We Do "), _createElementVNode("div", {
        class: "footer-text3-t3 footer-text",
        onClick: _cache[13] || (_cache[13] = $event => to('/career/opportunities'))
      }, " Opportunities "), _createElementVNode("div", {
        class: "footer-text3-t4 footer-text",
        onClick: _cache[14] || (_cache[14] = $event => to('/career/how_to_apply'))
      }, " How To Apply ")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "footer-text4-t1 footer-text foot-title",
        onClick: _cache[15] || (_cache[15] = $event => to('/social/index'))
      }, " Social Influence "), _createElementVNode("div", {
        class: "footer-text4-t2 footer-text",
        onClick: _cache[16] || (_cache[16] = $event => to('/social/co_communications'))
      }, " Co-Communications "), _createElementVNode("div", {
        class: "footer-text4-t3 footer-text",
        onClick: _cache[17] || (_cache[17] = $event => to('/social/responsibilities'))
      }, " Social Responsibilities ")]), _cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "footer-text5 footer-text-col"
      }, [_createElementVNode("div", {
        class: "footer-text5-t1 footer-text foot-title"
      }, "Contact Us"), _createElementVNode("div", {
        class: "footer-text5-t2 footer-text"
      }), _createElementVNode("div", {
        class: "footer-text5-t3 footer-text"
      })], -1))])]);
    };
  }
};